/**
 * PayrollRenderContext.tsx - Shared render context for payroll sub-components
 *
 * Phase 2: payroll-management.tsx component decomposition
 * Provides parent state/functions to extracted JSX components via React Context.
 */

import { createContext, useContext } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type PayrollRenderContextType = Record<string, any>;

const PayrollRenderContext = createContext<PayrollRenderContextType>({});

export const PayrollRenderProvider = PayrollRenderContext.Provider;

export function usePayrollRender(): PayrollRenderContextType {
  const ctx = useContext(PayrollRenderContext);
  if (!ctx || Object.keys(ctx).length === 0) {
    throw new Error('usePayrollRender must be used within PayrollRenderProvider');
  }
  return ctx;
}
